export const MAPPINGS_HELP_TEXT =
  "The'Mappings' feature to associate form submissions with contact details like name, email, and phone number, saving them in the 'Customers' tab for future communications if the submitter opts in to future communications.";
